(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chiije-discovery-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDiscovery(root) {
      if (!root || root.dataset.chiijeDiscoveryReady === '1') return;
      root.dataset.chiijeDiscoveryReady = '1';

      var max = Number(root.getAttribute('data-max') || 4);
      var options = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-scent]'));
      var countEl = root.querySelector('[data-chiije-discovery-count]');
      var addBtn = root.querySelector('[data-chiije-discovery-add]');
      var variantId = root.getAttribute('data-variant-id');

      function selected() {
        return options.filter(function (btn) {
          return btn.getAttribute('aria-pressed') === 'true';
        });
      }

      function refresh() {
        var picks = selected();
        var n = picks.length;
        if (countEl) countEl.textContent = n + ' of ' + max + ' chosen';

        options.forEach(function (btn) {
          if (btn.disabled) return;
          var on = btn.getAttribute('aria-pressed') === 'true';
          btn.classList.toggle('is-blocked', !on && n >= max);
        });

        if (!addBtn) return;
        if (n < max) {
          addBtn.disabled = true;
          addBtn.textContent = 'Choose ' + (max - n) + ' more';
        } else {
          addBtn.disabled = !variantId;
          addBtn.textContent = variantId ? 'Add my four' : 'Select discovery product';
        }
      }

      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var on = btn.getAttribute('aria-pressed') === 'true';
          if (on) {
            btn.setAttribute('aria-pressed', 'false');
          } else if (selected().length >= max) {
            return;
          } else {
            btn.setAttribute('aria-pressed', 'true');
          }
          refresh();
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var picks = selected();
          if (picks.length !== max || !variantId || !window.ChiijeCart) return;
          var properties = {};
          picks.forEach(function (btn, index) {
            var n = index + 1;
            var label = btn.getAttribute('data-number') || btn.getAttribute('data-name') || '';
            var name = btn.getAttribute('data-name') || '';
            var handle = btn.getAttribute('data-handle') || '';
            properties['Scent ' + n] = (label + (name ? ' · ' + name : '')).trim();
            if (handle) {
              properties['Scent ' + n + ' handle'] = handle;
            }
          });
          ChiijeCart.add(variantId, 1, properties, addBtn).catch(function () {
            addBtn.textContent = 'Error';
            window.setTimeout(refresh, 1400);
          });
        });
      }

      refresh();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-discovery]').forEach(initDiscovery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-chiije-discovery]');
      if (root) {
        root.dataset.chiijeDiscoveryReady = '';
        initDiscovery(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-hero-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.ready === '1') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-hero-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-hero-tab]'));
      if (slides.length < 2) return;
      root.dataset.ready = '1';

      var index = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = Number(root.getAttribute('data-interval') || 7000);
      root.style.setProperty('--chiije-hero-interval', interval + 'ms');

      function goTo(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        restartAutoplay();
      }

      function restartAutoplay() {
        window.clearInterval(timer);
        root.classList.toggle('is-autoplaying', autoplay);
        if (!autoplay) return;
        // retrigger progress animation
        tabs.forEach(function (tab) {
          var bar = tab.querySelector('.chiije-hero-film__tab-progress');
          if (!bar) return;
          bar.style.animation = 'none';
          void bar.offsetWidth;
          bar.style.animation = '';
        });
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          goTo(Number(tab.getAttribute('data-index') || 0));
        });
      });

      restartAutoplay();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-chiije-hero]')
        : null;
      if (root) {
        root.dataset.ready = '0';
        initHero(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-reuse"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReuse(root) {
      if (!root || root.dataset.chiijeReuseReady === '1') return;
      root.dataset.chiijeReuseReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-reuse-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-reuse-dot]'));
      var captionEl = root.querySelector('[data-chiije-reuse-caption]');
      var captions = slides.map(function (slide, index) {
        if (index === 0) {
          return (captionEl && captionEl.textContent.trim()) || '';
        }
        return slide.getAttribute('data-caption') || '';
      });
      var interval = Number(root.getAttribute('data-interval') || 6000);
      var index = 0;
      var timer = null;

      function show(next) {
        index = ((next % slides.length) + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (captionEl) captionEl.textContent = captions[index] || '';
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, interval);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-index') || 0));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
      });

      show(0);
      start();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-reuse]').forEach(initReuse);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-chiije-reuse]');
      if (root) {
        root.dataset.chiijeReuseReady = '';
        initReuse(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-shop-scents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-chiije-add]');
    if (!button || !window.ChiijeCart) return;
    event.preventDefault();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    ChiijeCart.add(variantId, 1, null, button).catch(function () {
      button.textContent = 'Error';
      window.setTimeout(function () {
        button.textContent = button.dataset.chiijeOriginalLabel || 'Add';
        button.disabled = false;
      }, 1400);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
